export default __webpack_public_path__ + "static/media/tag-dark.84cda7b3.svg";